var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-header pl-0" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", { staticClass: "dropdown mr-3 d-none" }, [
            _c(
              "ul",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "inspectorDropdown" }
              },
              [
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "main"
                        }
                      }
                    },
                    [_vm._v("Main")]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("span", { staticClass: "text-primary ml-3" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$parent.activeComponentTitle) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-menu-wrapper navbar navbar-expand-lg" },
            [
              _c("ul", { staticClass: "navbar-nav" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "span",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.activeComponent == "main" },
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "main"
                        }
                      }
                    },
                    [_vm._v("\n              Main\n            ")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "inspector-wrapper" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-9" },
            [_vm.activeComponent == "main" ? _c("maininspector") : _vm._e()],
            1
          ),
          _vm._v(" "),
          _vm.selectedImage
            ? _c("div", { staticClass: "col-3 position-relative" }, [
                _vm.selectedImage
                  ? _c("h4", [_vm._v(_vm._s(_vm.selectedImage.objectName))])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "selected-char-imgwrap mr-4" }, [
                  _c("img", {
                    staticClass: "img-fluid",
                    staticStyle: { width: "100%" },
                    attrs: { src: _vm.selectedImage.objectUrl }
                  })
                ])
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-3" }, [
      _c("img", {
        staticClass: "heading-icon mr-2",
        attrs: { src: require("@/assets/device_hub_icon.svg") }
      }),
      _vm._v(" Inspector")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-092d9002", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-092d9002","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-wrap/imagesInspector.vue
// module id = null
// module chunks = 